export default __webpack_public_path__ + "static/media/HydraulicCylinderImg.690f6fd8.jpg";